export const CLOVER_AMEX = 'AMEX';
export const CLOVER_DISCOVER = 'DISCOVER';
export const CLOVER_MASTERCARD = 'MC';
export const CLOVER_VISA = 'VISA';
